import Nullstack from 'nullstack';
export default function IconArrowRotaryLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-rotary-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
  }), "   ", Nullstack.element("path", {
    d: "M16 10v10"
  }), "   ", Nullstack.element("path", {
    d: "M13 7h-10"
  }), "   ", Nullstack.element("path", {
    d: "M7 11l-4 -4l4 -4"
  }), " ");
}